import { getPublicSettings, getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { isUserLoggedIn } from '@juvare/platform-sdk-react/ui/stores';
import { useSelector } from 'react-redux';
import { useCredentialingTranslation } from './useCredentialingTranslation';
const getClientCode = (settings) => { var _a, _b; return (_b = (_a = settings.esarVhp) === null || _a === void 0 ? void 0 : _a.clientCode) !== null && _b !== void 0 ? _b : ''; };
export function useTrainCourseFilters() {
    const { t } = useCredentialingTranslation();
    const userLoggedIn = useSelector(isUserLoggedIn);
    const settings = useSelector(userLoggedIn ? getSettings : getPublicSettings);
    const clientCode = getClientCode(settings);
    const trainCourseFilters = (builder) => {
        builder.allFiltersPanel({
            key: '!trainCourses',
            label: t('filters.trainCourses.groupTitle', { clientCode }),
            children: [
                builder.allFiltersWidget({
                    type: 'form.multiSelect',
                    valueProvider: {
                        type: 'classifier.trainCourse',
                    },
                    label: t('filters.trainCourses.courseName'),
                    key: 'trainCourseIds',
                }),
                builder.allFiltersWidget({
                    type: 'form.text',
                    label: t('filters.trainCourses.courseNumber'),
                    key: 'trainCourseTrainId',
                }),
            ],
        });
    };
    return { trainCourseFilters };
}
